import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import { settingsWorkspace, settingsAdmin } from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import builders from './sidebarItems/builders';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settingsAdmin(accountId), // Admin settings - matches first (general, billing, agents, teams, inboxes)
    settingsWorkspace(accountId), // Workspace settings - nut menu (labels, macros, etc.)
    notifications(accountId),
    builders(accountId),
  ],
});
